import CancelledIcon from '../../../assets/tasks/cancelled.svg';
import CompletedIcon from '../../../assets/tasks/completed.svg';
import InprogressIcon from '../../../assets/tasks/inprogress.svg';
import lateIcon from '../../../assets/tasks/late.svg';
import LateIcon from '../../../assets/tasks/late.svg';

import { TaskStatus } from '../../../models';

export const taskStatusMapper = (status: TaskStatus, isLate?: boolean) => {
  if (isLate) {
    return lateIcon;
  }

  switch (status) {
    case TaskStatus.InProgress:
      return InprogressIcon;
    case TaskStatus.Cancelled:
      return CancelledIcon;
    case TaskStatus.Completed:
      return CompletedIcon;
    case TaskStatus.Late:
      return LateIcon;
  }
};
